import React, { useEffect, useState } from 'react'
import SVG from 'react-inlinesvg'
import arrow from '../../../_metronic/images/arr072.svg'
import {
  KEY_PERFORMANCE_METRICS_FILTER
} from '../../../utils/GraphQLAPI'
import { useLazyQuery } from '@apollo/client'
import momentTimezone from 'moment-timezone'

export default function TeamAdminSaleschannelFilter({ getKeyPerformancemetricsData, colors }: any) {
  const [options, setOptions] = useState<any>([])
  const [searchOptions, setSearchOption] = useState<any>()
  const [selectedOptions, setSelectedOption] = useState<any>([])

  useEffect(() => {
    localStorage.removeItem('salesChannelFilter')
    getSalesChannelsForFilter({
      variables: {
        salesChannelListInput: {
          searchText: '',
          // page: 1,
          // perPage: 10,
        },
      },
    })
  }, [])

  // Filter Query
  const [getSalesChannelsForFilter] = useLazyQuery(KEY_PERFORMANCE_METRICS_FILTER, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setOptions(
        data.getSalesChannelListByTeamAdminWithFilter.salesChannels.map((x: any) => ({
          checked: false,
          ...x,
        }))
      )
    },
  })

  // Search the dropdown value
  const search = (event: any) => {
    const searchValue = event.target.value
    setSearchOption(event.target.value)
    getSalesChannelsForFilter({
      variables: {
        salesChannelListInput: {
          searchText: searchValue,
          // page: 1,
          // perPage: 10,
        },
      },
    })
  }

  // Clear all the selected Checkbox
  const clearAllCheckbox = async () => {
    setSelectedOption([])
    setSearchOption('')
    getSalesChannelsForFilter({
      variables: {
        salesChannelListInput: {
          searchText: '',
          // page: 1,
          // perPage: 10,
        },
      },
    })
    localStorage.removeItem('salesChannelFilter')
    getKeyPerformancemetricsData({ variables: { saleChannelsIds: null } })
  }

  // Function to select and unselect the checkboxes
  const onSelect = (e: any, data: any) => {
    if (e.target.checked) {
      setSelectedOption([...selectedOptions, data.id])
      const checkedUpdate1 = options.map((eachData: any) => {
        if (eachData.id === data.id) {
          eachData.checked = true
        }
        return eachData
      })
      setOptions(checkedUpdate1)
    } else {
      const dataPresent: any = selectedOptions?.indexOf(data.id)
      selectedOptions.splice(dataPresent, 1)
      setSelectedOption(selectedOptions)
      const checkedUpdate2 = options.map((eachData: any) => {
        if (eachData.id === data.id) {
          eachData.checked = false
        }
        return eachData
      })
      setOptions(checkedUpdate2)
    }
  }

  // Applying Filters to query the data
  const applyFilters = () => {
    if (selectedOptions.length === 0) {
      getKeyPerformancemetricsData({
        variables: { localTimeZone: momentTimezone.tz.guess(), saleChannelsIds: null },
      })
    } else {
      getKeyPerformancemetricsData({
        variables: { localTimeZone: momentTimezone.tz.guess(), saleChannelsIds: selectedOptions },
      })
    }
  }
  return (
    <>
      <div className='h-38px border-0 rounded'>
        <a
          href='#'
          className={`btn btn-sm d-flex align-items-center justify-content-between w-170px ${colors === 'dark' ? 'btn btn-lignt btn-sm  bg-secondary ' : 'bg-white'}`}
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          style={{
            borderRadius: '6px',
            height: '43px',
            width: '218px',
            paddingLeft: '30px',
            color: '#7E8299',
          }}
        >
          {selectedOptions.length === 0
            ? 'All Sales Channel'
            : `${selectedOptions.length} Selected`}

          <span className={`svg-icon svg-icon-2`}>
            <SVG src={arrow} width='22px' height='22px' />
          </span>
        </a>

        {/* begin::Menu */}
        <div
          className=' menu menu-sub menu-sub-dropdown'
          style={{ width: '220px' }}
          data-kt-menu='true'
        >
          <div className='mx-1 my-1 menu-item' data-kt-sticky-top='auto'>
            <input
              type='text'
              // data-kt-user-table-filter='search'
              style={{ width: '210px' }}
              className='form-control form-control-solid'
              placeholder='Search'
              value={searchOptions}
              onChange={(e) => {
                search(e)
              }}
            />
          </div>

          <div
            className='menu-column menu-gray-600 overlay-y menu-state-bg-primary fs-7 py-4 w-160px'
            // data-kt-menu='true'
            style={{
              borderRadius: '6px',
              width: '215px',
              maxHeight: '304px',
              overflowY: 'scroll',
            }}
          >
            {options.map((optionData: any, index: any) => {
              return (
                <div
                  className='menu-item w-160px'
                  style={{ width: '200px ', padding: '12px 16px' }}
                  key={index}
                >
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={optionData?.checked}
                      value={optionData.name}
                      onClick={(e) => {
                        onSelect(e, optionData)
                      }}
                    />
                    <label
                      htmlFor=''
                      style={{ color: '#5E6278' }}
                      className='form-check-label fw-semibold fs-5'
                    >
                      {optionData.name}
                    </label>
                  </div>
                </div>
              )
            })}
          </div>

          <div className='menu-item my-1'>
            <button
              style={{
                width: '85px',
                height: '36px',
                marginBottom: '10px',
                marginRight: '10px',
                fontSize: '13px',
              }}
              className='btn btn-secondary w-59px h-36px mx-4 p-0'
              onClick={clearAllCheckbox}
            >
              Clear
            </button>
            <button
              style={{
                width: '85px',
                height: '36px',
                marginBottom: '10px',
                marginRight: '10px',
                fontSize: '13px',
              }}
              className='btn btn-primary w-59px h-36px mx-2 me-3 p-0'
              onClick={applyFilters}
              data-kt-menu-dismiss='true'
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
